import { Icon } from "@alm/flow-ds/components";
import { isAdmin, isManager } from "data/app/appSelectors";
import React from "react";
import { useSelector } from "react-redux";
import MenuItem from "./MenuItem";

export default function MenuClosed() {
	// Show admin menu options if user is admin
	const admin = useSelector(isAdmin);
	const manager = useSelector(isManager);

	return (
		<>
			<ul className="menu__top">
				{/* <MenuItem>
					<Icon
						type="home-lg-alt"
						weight="l"
						size="sm"
						fixedWidth></Icon>
				</MenuItem> */}
				<MenuItem name="tasks">
					<Icon type="list" weight="l" size="sm" fixedWidth></Icon>
				</MenuItem>
				{manager && (
					<MenuItem name="manager">
						<Icon
							type="clipboard-check"
							weight="l"
							size="sm"
							fixedWidth></Icon>
					</MenuItem>
				)}
				<MenuItem name="views">
					<Icon type="search" weight="l" size="sm" fixedWidth></Icon>
				</MenuItem>
				{admin && (
					<MenuItem name="config">
						<Icon
							type="sliders-h"
							weight="l"
							size="sm"
							fixedWidth></Icon>
					</MenuItem>
				)}
			</ul>
			{/*<ul className="menu__bottom">
				<MenuItem name="settings">
					<Icon type="cog" weight="l" size="sm" fixedWidth></Icon>
				</MenuItem>
				 <MenuItem>
					<Icon
						type="question-circle"
						weight="l"
						size="sm"
						fixedWidth></Icon>
				</MenuItem>
				<MenuItem name="logout">
					<Icon
						type="door-closed"
						weight="l"
						size="sm"
						fixedWidth></Icon>
				</MenuItem>
			</ul>*/}
		</>
	);
}
